module.exports = __webpack_public_path__ + "img/payment-method-bst.541a9010.png";